import { APP_THEME } from "@/data/constants";
import usePricingStore from "@/store/pricing-store";
import useReviewStore from "@/store/review-store";
import useSaleModeStore from "@/store/sale-mode-store";

export const resetSaleMode = () => {
  useSaleModeStore.getState().reset();

  const promoCodeFromParam = new URLSearchParams(window.location.search).get(
    "promo_code",
  );
  usePricingStore.setState({
    pricingPromoCode: promoCodeFromParam ?? undefined,
  });

  usePricingStore.setState({ pricingTheme: APP_THEME.LIGHT });
  useReviewStore.setState({ reviewTheme: APP_THEME.LIGHT });
};
